<template>
  <div>
    <div class="mt-10">
      <v-dialog width="800" v-model="changeTimeModal" v-if="$vuetify.breakpoint.mdAndUp">
        <v-card-text class="white" v-if="changeTimeModal">
          <TimeCalendarWithTimezoneChange
              v-if="firstTime"
              @resetTimesBox="resetTimesBox"
              @selectTime="selectTime($event)"
              :selected-time="selectedTime"
              :first-time="firstTime" :times="times"
          />
          <div class="footerContext mt-4">
            <v-row>
              <v-col cols="12" lg="6">
                <v-fade-transition>
                  <div class="sessionInfoBtn d-flex flex-column justify-center  fill-height" v-if="selectedTime">
                    <div class="">
                      {{ selectedTime.from_time | jalaliDateTime }}
                      {{ selectedTime | getDayPeriodsLabel }}

                      <span style="color:#035184;font-family: Roboto !important">
                          ( {{ profile.tz }} )
                        </span>
                    </div>
                  </div>
                </v-fade-transition>
              </v-col>
              <v-col cols="12" lg="6">
                <v-btn color="#39C990" @click="changeTime" elevation="0"
                       class="confirmBtn white--text" block>
                  تایید و ادامه
                </v-btn>
              </v-col>
            </v-row>
          </div>

        </v-card-text>
      </v-dialog>
      <v-dialog scrollable fullscreen style="border-radius: 16px 16px 0px 0px " v-model="changeTimeModal"
                v-if="$vuetify.breakpoint.mdAndDown">
        <v-bottom-navigation height="80px" fixed class="bottomNavigation"
                             v-if="selectedTime && $vuetify.breakpoint.mdAndDown">
          <v-row class="pa-0 ma-0">
            <v-col cols="6" class="pa-0 ma-0">
              <v-fade-transition>
                <div class="sessionInfoBtn d-flex flex-column justify-center  fill-height" v-if="selectedTime">
                  <div class="">
                    {{ selectedTime.from_time | jalaliDateTimePartOne }}
                    <br>
                    {{ selectedTime.from_time | jalaliDateTimePartTwo }}
                    {{ selectedTime | getDayPeriodsLabel }}

                    <span style="color:#035184;font-family: Roboto !important;">
                          ({{ profile.tz }})
                        </span>
                  </div>
                </div>
              </v-fade-transition>
            </v-col>
            <v-col cols="6" class="pa-0 ma-0 d-flex flex-column justify-center">
              <v-btn color="#39C990" @click="changeTime" elevation="0" style="color: white !important;"
                     class="confirmBtn white--text" block>
                تایید و ادامه
              </v-btn>
            </v-col>
          </v-row>
        </v-bottom-navigation>

        <div class="changeTimeContext fill-height" style="border-radius: 16px 16px 0px 0px ">
          <div style="margin-top: 0px" class="whiteBox">
            <div class="d-flex" @click="changeTimeModal = false">
              <div class=" d-flex flex-column justify-center">
                <img src="../../assets/image/user-journey/arrow-narrow-right-black.svg" alt="">
              </div>
              <div class="font-weight-bold d-flex flex-column justify-center ">
                بررسی و رزرو نوبت
              </div>
            </div>
          </div>

          <TimeCalendarWithTimezoneChange
              v-if="firstTime"
              @resetTimesBox="resetTimesBox"
              @selectTime="selectTime($event)"
              :selected-time="selectedTime"
              :first-time="firstTime" :times="times"
          />

        </div>
      </v-dialog>
      <div class="cardRequest" v-if="request">
        <div class="doctorArea">
          <div class="d-flex">
            <div class="doctorImage">
              <img :src="request.doctor.user.avatar" alt="">
            </div>
            <div class="d-flex flex-column justify-center">
              <div class="doctorName">
                دکتر
                {{ request.doctor.user.full_name }}
              </div>
              <div class="doctorSubTitle">

                {{ request.doctor.subtitle }}
              </div>
            </div>
          </div>
        </div>
        <div class="payArea">
          <div class="d-flex justify-space-between">
            <div class="hintArea d-flex flex-column justify-center">
              <div class="d-flex">
                <div class="d-flex flex-column justify-center ml-2">
                  <img src="../../assets/image/user-journey/alert-square-rounded-filled.svg" alt="">
                </div>
                <div>
                  زمان انتخاب شده تا
                  <b>
                    1 ساعت دیگر
                  </b>
                  برای شما رزرو خواد ماند و در صورت عدم پرداخت لغو خواهد شد.
                </div>
              </div>
            </div>
            <div v-if="$vuetify.breakpoint.mdAndUp">
              <v-btn class="PayBtn" color="#39C990" elevation="0" @click="payFactor">
                پرداخت
              </v-btn>
            </div>
          </div>
        </div>
        <div class="factorArea">
          <v-row>
            <v-col cols="12" lg="6">
              <div class="titleItem">
                نوع بسته:
              </div>
              <div class="contentItem">
                {{ request.cart.cart_packages[0].package.title }}
              </div>
            </v-col>
            <v-col cols="12" lg="6">
              <div class="titleItem">
                مبلغ قابل پرداخت:
              </div>
              <div class="contentItem" style="font-family: Roboto !important;">
                {{ request.cart.final_amount }}
                $
              </div>
            </v-col>
          </v-row>
        </div>
        <div class="sessionInfo">
          <v-row class="ma-0 pa-0">
            <v-col cols="12" lg="4" class="ma-0 pa-0 pt-2  d-flex flex-column justify-center">
              <div class="sessionInfoItem">
                <div>
                  <img src="../../assets/image/user-journey/calendar.svg" alt="">
                </div>
                <div class="sessionInfoData">
                  {{ request.date_time.from_time | dateFilter }}
                </div>
              </div>
            </v-col>
            <v-col cols="12" lg="4" class="ma-0 pa-0 pt-2  d-flex flex-column justify-center">
              <div class="sessionInfoItem">
                <div>
                  <img src="../../assets/image/user-journey/clock.svg" alt="">
                </div>
                <div class="sessionInfoData">
                  {{ request.date_time.from_time | jalaliDateTimePartTwo }}
                  {{ request.date_time | getDayPeriodsLabel }}
                  <span style="font-family: Roboto !important">
                  (
                  {{ profile.tz }}
                  )
                  </span>

                </div>
                <v-spacer v-if="$vuetify.breakpoint.mdAndDown"></v-spacer>
                <div v-if="$vuetify.breakpoint.mdAndDown">
                  <v-btn @click="openModalChangeTime" x-small elevation="0" text color="#39C990" class="changeTime">
                    تغییر زمان
                    <img src="../../assets/image/user-journey/chevron-green.svg" width="15"/>
                  </v-btn>
                </div>
              </div>
            </v-col>
            <v-col cols="12" lg="4" class="ma-0 pa-0 pt-2  d-flex flex-column justify-center"
                   v-if="$vuetify.breakpoint.mdAndUp">
              <div class="text-left">
                <v-btn elevation="0" @click="openModalChangeTime" text color="#39C990" class="changeTime">
                  تغییر زمان
                  <img src="../../assets/image/user-journey/chevron-green.svg"/>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </div>
        <div v-if="$vuetify.breakpoint.mdAndDown" class="mt-5">
          <v-btn class="PayBtn" color="#39C990" elevation="0" block @click="payFactor">
            پرداخت
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable*/
import momentJalali from "moment-jalaali";
import {mapGetters} from "vuex";
import TimeCalendarWithTimezoneChange from "@/components/UserJourney/TimeCalendarWithTimezoneChange.vue";

export default {
  components: {TimeCalendarWithTimezoneChange},
  data() {
    return {
      request: null,
      changeTimeModal: false,
      times: [],
      firstTime: null,
      selectedTime: null,
    }
  },
  computed: {
    ...mapGetters({
      profile: 'getProfile'
    })
  },
  methods: {
    changeTime() {
      this.$emitEvent('setLoading', true)
      this.requesting('setSession', 'changeTimeSession', {}, {
        time_id: this.selectedTime.id,
        journey_id: this.request.id
      }).then(() => {
        this.changeTimeModal = false
        this.getRequest()
        this.$emitEvent('notify', {color: 'green', title: 'تغیرزمان انجام شد'});

      }).finally(() => {
        this.$emitEvent('setLoading', false)
      })
    },
    openModalChangeTime() {
      this.changeTimeModal = true
      this.getTimes()
    },
    groupingTime(times) {
      this.reloadTime = true
      console.log(this.times, 'times')
      times.forEach((item) => {
        let date = momentJalali(item.date).format('YYYY-MM-DD')
        let time = this.times.find(i => i.date == date)
        if (!time) {
          this.times.push({
            date: date,
            id: item.id,
            periods: [item],
            morning: [],
            evening: [],
            night: [],
          })
        } else {
          time.periods.push(item)
        }
      })

      this.chunkTimesByPeriod(this.times)
    },
    chunkTimesByPeriod(times) {
      times.forEach(item => {
        item.periods.forEach((time) => {
          const hour = parseInt(momentJalali(time.from_time).format('HH'));
          if (hour) {
            if (hour >= 0 && hour < 12) {
              item.morning.push(time);
            } else if (hour >= 12 && hour < 18) {
              item.evening.push(time);
            } else if (hour >= 18 && hour <= 23) {
              item.night.push(time);
            }
          }
        })

      });
      this.reloadTime = false
    },

    getTimes() {
      this.times = []
      this.$emitEvent('setLoading', true)
      this.requesting("session", 'getDoctorTime', {doctorId: this.request.doctor_id}).then((resp) => {
        this.firstTime = resp.data.times[0]
        this.selectedTime = resp.data.times[0]

        this.groupingTime(resp.data.times)

      }).finally(() => {
        this.$emitEvent('setLoading', false)
      })
    },
    selectTime(time) {
      this.selectedTime = time
    },
    resetTimesBox() {
      this.times = []
      this.selectedTime = null
      this.getTimes()
    },
    getRequest() {
      this.requesting('setSession', 'getCartSubmitted').then((resp) => {
        this.request = resp.data.journey
      })
    },
    payFactor() {
      this.$emitEvent('setLoading', true)

      this.requesting('setSession', 'selectPackage', {}, {
        token: this.request.token,
        package_id: this.request.cart.cart_packages[0].package_id,
        cart_id: this.request.cart_id
      }).then((resp) => {
        window.location = resp.data.payment.url
      }).finally(() => {
        this.$emitEvent('setLoading', false)
      })
    }
  },
  filters: {

    jalaliDateTimePartOne(value) {
      if (!value) return '';

      const m = momentJalali(value, "YYYY-MM-DD HH:mm");
      if (!m.isValid()) return value;

      return m.locale('fa').format('dddd YYYY/MM/DD ');
    },

    jalaliDateTime(value) {
      if (!value) return '';

      const m = momentJalali(value, "YYYY-MM-DD HH:mm");
      if (!m.isValid()) return value;

      return m.locale('fa').format('dddd YYYY/MM/DD - [ساعت] hh:mm');
    },


    dateFilter(value) {
      if (!value) return ''
      momentJalali.loadPersian({dialect: 'persian-modern'});
      return momentJalali(value, 'YYYY-MM-DD HH:mm')
          .locale('fa')
          .format('dddd، jDD jMMMM jYYYY')
    },
    jalaliDateTimePartTwo(value) {
      if (!value) return '';
      const m = momentJalali(value, "YYYY-MM-DD HH:mm");
      if (!m.isValid()) return value;
      return m.locale('fa').format('hh:mm');
    },
    getDayPeriodsLabel(time) {
      const hour = parseInt(momentJalali(time.from_time).format('HH'));
      console.log(hour, '1212')
      if (hour) {
        if (hour >= 0 && hour < 12) {
          return 'صبح'
        } else if (hour >= 12 && hour < 18) {
          return 'عصر'
        } else if (hour >= 18 && hour <= 23) {
          return 'شب'
        }
      }
    },
  },
  mounted() {
    this.getRequest()
  },

}
</script>

<style lang="scss" scoped>
@media (min-width: 200px) and (max-width: 800px) {
  .doctorName {
    font-size: 18px !important;
  }

  .doctorSubTitle {
    font-size: 16px !important;
  }
  .hintArea {
    height: auto !important;
    padding: 8px 12px !important;
  }
  .sessionInfoData {
    font-size: 14px !important;
  }
  .changeTime {
    font-size: 12px !important;
  }
  .sessionInfo {
    border-bottom: 1px solid #EAF0F6 !important;
  }

  .confirmBtn {
    height: 48px !important;
    font-size: 16px !important;
    color: white !important;
    border-radius: 8px !important;
  }


  .sessionInfoBtn {
    font-size: 13px !important;
  }

  .cardRequest {
    padding: 16px !important;
  }
}

.changeTimeContext {
  background: #F6F9FC;
}

.confirmBtn {
  height: 50px !important;
  font-size: var(--Font-Size-Xl, 16px);
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border-radius: 8px;
}


.footerContext {
  //box-shadow: 0 -2px 4px 0 rgba(219, 228, 237, 0.40);
  //padding: 16px 24px;
}

.bottomNavigation {
  box-shadow: 0 -2px 4px 0 rgba(219, 228, 237, 0.40) !important;
  padding: 16px 24px;
}

.sessionInfoBtn {
  color: var(--grey-grey-darken-3, #424242);
  /* Body/Large/Medium18 */
  font-size: var(--Font-Size-xl, 18px);
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}


.changeTime {
  color: #39C990;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.sessionInfoData {
  color: #424242;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
}

.sessionInfoItem {
  display: flex;
}

.titleItem {
  color: #616161;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
}

.contentItem {
  color: #424242;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 4px;
}

.factorArea {
  padding: 16px 0px;
  border-bottom: 1px solid #EAF0F6;
}

.sessionInfo {
  padding: 16px 0px;
}

.hintArea {
  height: 50px;
  padding: 12px 24px;
  border-radius: 8px;
  background: rgba(255, 236, 223, 0.70);
  color: #FFA362;
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 171.429% */
}

.titleWhiteBox {
  color: #616161;
  font-size: 14px;
  font-weight: 500;
}

.whiteBox {
  margin-top: 8px;
  background: white;
  padding: 10px 24px;
}


.PayBtn {
  width: 135px;
  height: 48px !important;
  padding: 0 19.55px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;

  color: #FFF;

  /* Title/Small/Bold16 */
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.payArea {
  border-bottom: 1px solid #EAF0F6;
  padding: 16px 0px;
}

.doctorName {
  color: #212121;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.doctorSubTitle {
  color: #616161;
  margin-top: 3px;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.doctorImage img {
  width: 80px;
  height: 80px;
}

.cardRequest {
  border-radius: 8px;
  border: 1px solid #EAF0F6;
  padding: 16px 24px;
}

.doctorArea {
  border-bottom: 1px solid #EAF0F6;
}
</style>